<template>
    <b-card no-body>
        <b-card-body>
            <b-card bg-variant="light">

                <b-form-row @keyup.enter="load">
                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Sistema:" v-model="form.sistema"
                            :options="form.optionsFilterSistema" @change="load" />
                    </b-col>
                    <b-col lg="2" sm="12" class="text-left">
                        <lg-form-const-select label="Situação:" v-model="form.situacao"
                            :options="form.optionsFilterSituacao" @change="load" :disabled="desativarSituacao" />
                    </b-col>

                    <b-col lg="4" sm="12" class="text-left">
                        <lg-form-input label="Perfil:" v-model="form.perfil" @change="load" />
                    </b-col>

                    <b-col cols="4" class="text-right mt-2">

                        <b-button id="limparPerfil" class="my-2" size="sm" style="height: 20px" pill variant="primary"
                            @click="clearForm">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="eraser" />
                            </div>
                            <b-tooltip target="limparPerfil" title="Limpar"></b-tooltip>
                        </b-button>

                        <b-button id="localizarPerfil" class="ml-3 mr-2 my-2" size="sm" style="height: 20px" pill
                            variant="primary" @click="load">
                            <div class="btn-size-alinhamento">
                                <b-icon icon="search" />
                            </div>
                            <b-tooltip target="localizarPerfil" title="Localizar"></b-tooltip>
                        </b-button>

                        <b-button id="novoPerfil" class="ml-3 mr-2 my-2" style="height: 20px"
                            @click="showModalForm(null)" size="sm" pill variant="secondary">
                            <div class="btn-size-alinhamento">
                                <b-icon scale="1" icon="plus" />
                            </div>
                            <b-tooltip target="novoPerfil" title="Adicionar novo..."></b-tooltip>
                        </b-button>


                    </b-col>
                </b-form-row>
            </b-card>

            <b-card bg-variant="light">
                <b-table responsive class="mt-2" small :busy="this.busy" :items="this.records"
                    :fields="this.tableFields" :filter="filtro" :hover="true" @row-dblclicked="perfilSelect" show-empty>

                    <template #empty>
                        <p>Nenhum registro encontrado</p>
                    </template>


                    <template #table-busy>
                        <div class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                        </div>
                    </template>

                    <template v-slot:cell(buscar)="row">



                        <b-button v-b-tooltip.hover.bottom="'Consultar...'" class="my-2" @click="consultar(row.item)" size="sm" pill
                            variant="secondary">
                            <b-icon icon="search" />
                        </b-button>


                    </template>


                    <template v-slot:cell(situacao)="row">
                        <b-form-checkbox v-b-tooltip.hover.bottom="'Ativar/Desativar...'" v-model="row.item.situacao"
                            @change="alteraSituacao(row.item)" name="check-button" switch size="lg" :value="1"
                            :unchecked-value="0" />
                    </template>

                    <template v-slot:cell(editar)="row">
                        <b-button v-b-tooltip.hover.bottom="'Editar'" :id="row.index + 'edit-button-perfil'" class="my-2" size="sm" pill variant="primary"
                            @click="showModalForm(row.item)">
                            <b-icon icon="pencil-square" />
                        </b-button>
                    </template>

                    <template v-slot:cell(bloquear)="row">

                        <b-button v-b-tooltip.hover.bottom="'Desbloquear'" v-if="row.item.visivel == 0" :id="row.index + 'bloquear-button'" class="my-2"
                            size="sm" pill variant="primary" @click="alteraVisivel(row.item)">
                            <b-icon icon="unlock-fill" />
                        </b-button>

                        <b-button v-b-tooltip.hover.bottom="'Bloquear'" v-if="row.item.visivel == 1" :id="row.index + 'bloquear-button'" class="my-2"
                            size="sm" pill variant="primary" @click="alteraVisivel(row.item)">
                            <b-icon icon="lock-fill" />
                        </b-button>


                    </template>


                </b-table>

                <b-row style="margin-top: 12px" v-if="records && records.length > 0">
                    <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Página {{ page }} de
                            {{
                            totalPage }} -
                            {{ total }} registros</b-col>
                        <b-col cols="6" style="display: flex; align-items: center; font-size: 12px">Mostrando:&nbsp;
                            <b-form-select size="sm" v-model="perPage" @change="() => this.load()"
                                :options="perPageOptions">
                            </b-form-select>
                        </b-col>
                    </b-col>
                    <b-col cols="6">
                        <div class="d-flex justify-content-end align-items-end">
                            <b-pagination style="margin-bottom: 10px; margin-top: 10px" v-model="page"
                                :per-page="perPage" :total-rows="total"></b-pagination>
                        </div>
                    </b-col>
                </b-row>
            </b-card>
        </b-card-body>
        <PerfilForm v-if="showModal" :prefix="prefix + title + ' > '" :id="id" @close="cancelar"></PerfilForm>
    </b-card>
</template>

<script>
import PerfilForm from "./PerfilForm.vue";
import ResourceService from "@/core/api/ResourceService";
import LgFormConstSelect from "@/core/components/Form/LgFormConstSelect.vue";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { ListResourceMixin } from "@/core/mixins/resource";
import ConfirmMixin from "@/core/mixins/confirm"

export default {
    name: "PerfilList",

    components: {
        LgFormInput,
        LgFormConstSelect,
        PerfilForm,

    },

    props: {
        onDblClickUsuarioPerfil: Function,
        desativarSituacao: {
            type: Boolean,
            default: false,
        },
        prefix: {
            type: String,
            default: "",
        }
    },

    created() {
        const brand = JSON.parse(localStorage.getItem("context"));
        this.form.unidadeAdministrativa = brand.departamento.nome;
        this.form.departamento = brand.departamento;
        this.form.usuario = brand.usuario;
    },

    data() {
        return {
            id: null,
            showModal: false,
            title: "Perfil",
            perPage: 10,
            perPageOptions: [10, 25, 50, 100],
            filtro: "",
            form: {
                perfil: "",
                situacao: "1",

                sistema: null,
                optionsFilterSituacao: [
                    { key: "filterSituacao", text: "Todos", value: null },
                    { key: "filterSituacao", text: "Ativo", value: "1" },
                    { key: "filterSituacao", text: "Inativo", value: "0" },
                ],

                optionsFilterSistema: [
                    { key: "filterSistema", text: "Todos", value: null },
                    { key: "filterSistema", text: "SGU", value: "1" },
                    { key: "filterSistema", text: "SPALM", value: "2" },
                ],
            },
        };
    },
    mixins: [ListResourceMixin, ConfirmMixin],
    beforeMount() {
        this.$service = new ResourceService(`/api/sgu/sistemas/perfis`);
    },
    mounted() {
        this.load();
    },

    watch: {
        page() {
            this.load();
        },
    },

    computed: {

        tableFields() {
            return [
                {
                    key: "perfil",
                    label: "Perfil",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "descricao",
                    label: "Descrição",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "sistema.nome",
                    label: "Sistema",
                    thStyle: "font-size: 16px; font-weight: 400;",
                    tdStyle: "font-size: 13px",
                },
                {
                    key: "buscar",
                    label: " ",
                    thClass: "w-1",
                },
                {
                    key: "editar",
                    label: " ",

                    thClass: "w-1"
                },
                {
                    key: "bloquear",
                    label: " ",
                    tdClass: "w-1",

                },
                {
                    key: "situacao",
                    label: " ",
                    tdClass: "text-center",
                    thClass: "w-1"
                },
            ];
        },
    },

    methods: {
        cancelar() {
            this.id = null;
            this.showModal = false;
            this.load();
        },
        showModalForm(item) {
            if (item)
                this.id = item.id;
            this.showModal = true;
        },
        perfilSelect(item) {
            this.$emit("onselect", item);


        },
        consultar() {
            this.$notify({
                type: "warning",
                message: "Em desenvolvimento",
            });
        },
        async load() {

            let filtro = {};
            if (this.form.perfil && this.form.perfil.length > 0) {
                filtro.descricao = this.form.perfil;
            }

            if (this.form.situacao != undefined) {
                filtro.situacao = this.form.situacao;
            }
            if (this.form.sistema != undefined && this.form.sistema != null) {
                filtro.sistema = this.form.sistema;
            }


            this.busy = true
            await this.$loadResource({
                size: this.perPage,
                page: this.page,
                params: filtro,
            });
        },

        clearForm() {
            this.form.perfil = "";
            this.form.sistema = null;
            this.form.situacao = "1";

            this.load();
        },


        async alteraSituacao(item) {
            let response = await this.$confirm(
                "Deseja " + (item.situacao === 1 ? "ativar" : "desativar") + " o Perfil?",
                item.descricao.toUpperCase()
            )


            if (response == true) {
                this.confirmarAtivaInativa(item)
            }
            else
                item.situacao = item.situacao === 1 ? 0 : 1
        },

        async confirmarAtivaInativa(item) {
            const { status } = await this.$service.alteraSituacao(item);

            if (status === 200) {
                this.$notify({
                    type: "success",
                    message: "Registro atualizado com sucesso.",
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: "Erro ao atualizar o registro.",
                })
            }
        },

        async alteraVisivel(item) {
            let response = await this.$confirm(
                "Deseja " + (item.visivel === 0 ? "bloquear" : "desbloquear") + " o Perfil " + item.perfil.toUpperCase() + " para os responsáveis?"

            )


            if (response == true) {
                this.confirmarAlteraVisivel(item)
            }
        },

        async confirmarAlteraVisivel(item) {
            const { status } = await this.$service.alteraVisivel(item);

            item.visivel = item.visivel == 1 ? 0 : 1;
            if (status === 200) {
                this.$notify({
                    type: "success",
                    message: "Registro atualizado com sucesso.",
                })
            } else {
                this.$notify({
                    type: "danger",
                    message: "Erro ao atualizar o registro.",
                })
            }
        },

    },
};
</script>
